export enum PromotionRelegationRuleTypes {
  PROMOTION = "PROMOTION",
  RELEGATION = "RELEGATION",
}
